module.exports = __webpack_public_path__ + "cbde9860d77ab6fe00a5fcda735620a1.png";